import Link from 'next/link';
import { UserMenuOptions } from '@ui/header/constants';
import { nanoid } from 'nanoid';
import { MdChevronRight } from 'react-icons/md';


// Store
import useStore from '@store';

export default () => {
	const $state = useStore();
	const { user } = $state?.auth || {};
	const role = user?.profile?.member_type.toLowerCase();
	const options = UserMenuOptions[role] || [];

	return (
		<div className={`flex flex-col gap-6 mt-6`}>
			{options.map((item, index) => {
				if (index === options.length - 1) return null;
				return (
					<Link
						href={item?.link}
						target={item?.target || '_self'}
						key={nanoid(5)}
						className={`text-white flex flex-row items-center gap-4 `}>
						{item.icon}
						<span className={`flex flex-1`}>{item.label}</span>
						<MdChevronRight className={`text-2xl`} />
					</Link>
				);
			})}
		</div>
	);
}
